import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import customIcons from '../utils/icons';
import { ModalProps } from '../types/global';
import Button from './buttons/baseButton';

export default function Modal({
  children,
  isOpen,
  onClose,
  size = 'default',
}: ModalProps) {
  const modalRef = useRef<HTMLDialogElement | null>(null);
  const modalRoot = document.body;

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      if (isOpen) {
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isOpen]);

  const handleCloseModal = () => {
    onClose();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDialogElement>) => {
    if (event.key === 'Escape') {
      handleCloseModal();
    }
  };
  const sizeClass = size === 'large'
    ? '!max-h-[90vh] !h-fit'
    : '';
  return ReactDOM.createPortal(
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <dialog
      id="modal"
      ref={modalRef}
      onKeyDown={handleKeyDown}
      className={`modal-container ${sizeClass}`}
      style={{
        scrollbarColor: '#4E9FFF #E7E7E7',
        scrollbarGutter: 'stable',
        scrollBehavior: 'smooth',
      }}
    >
      <div id="modal-content" className="min-h-full w-full overflow-y-auto">
        {children}
      </div>
      <Button
        id="close-filter-modal"
        icon={customIcons.closeIcon}
        label=""
        className="absolute top-0 right-0 p-1 m-4 bg-white"
        onClick={handleCloseModal}
      />
    </dialog>,
    modalRoot,
  );
}
